import GroupsIcon from '@mui/icons-material/Groups';

export const GroupsIconMUI = GroupsIcon;
